export function notNullable<T>(x: T | undefined | null): T {
  if (x === null || typeof x === 'undefined') {
    throw new Error('Expected a variable to be defined');
  }

  return x;
}
